import axios from "axios";
import {
  GetTenderResponse,
  GetTenderSituationResponse,
  CreateTenderRequest,
  CreateTenderResponse,
} from "./dto/Tender";
import { ErrorResponse } from "./dto/Error";

/**
 * 入札情報取得
 * @param dealId - 取引 ID
 * @returns {GetTenderResponse} - 入札情報取得 API レスポンス
 */
export const getTender = async (dealId: string): Promise<GetTenderResponse> => {
  const res = await axios.get<GetTenderResponse>(`/api/tender?id=${dealId}`, {
    headers: { "Content-Type": "application/json;charset=utf-8" },
  });
  return res.data;
};

/**
 * 入札情報登録
 * @param req リクエスト
 * @returns {CreateTenderResponse} - 入札情報登録 API レスポンス
 */
export const createTender = async (
  req: CreateTenderRequest
): Promise<CreateTenderResponse> => {
  const res = await axios.post<CreateTenderResponse>("/api/tender", req, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

/**
 * 入札情報削除
 * @param {string} dealId - 取引 ID
 */
export const deleteTender = async (dealId: string): Promise<void> => {
  await axios.delete<void>(`/api/tender?id=${dealId}`).catch((e) => {
    if (axios.isAxiosError(e)) {
      throw e.response?.data as ErrorResponse;
    }
  });
};

/**
 * 入札情報一括削除
 * @param {string} dealId - 取引 ID
 */
export const deleteTenders = async (dealId: string): Promise<void> => {
  await axios.delete<void>(`/api/tenders?id=${dealId}`).catch((e) => {
    if (axios.isAxiosError(e)) {
      throw e.response?.data as ErrorResponse;
    }
  });
};

/**
 * 入札状況取得
 * @param dealId - 取引 ID
 * @returns {GetTenderSituationResponse[]} - 入札状況取得 API レスポンス
 */
export const getTenderSituation = async (
  dealId: string
): Promise<GetTenderSituationResponse[]> => {
  const res = await axios.get<GetTenderSituationResponse[]>(
    `/api/tender/situation?id=${dealId}`,
    {
      headers: { "Content-Type": "application/json;charset=utf-8" },
    }
  );
  return res.data;
};
